export default __webpack_public_path__ + "static/media/roadmap-full-new.2d5755e5.png";